import { useState } from "react";
import { MessageCircle, MapPin, Image } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
export type RibbonType = "messages" | "address" | "media";
interface ChatRibbonsProps {
  activeRibbon: RibbonType;
  onRibbonChange: (ribbon: RibbonType) => void;
}
const ChatRibbons = ({
  activeRibbon,
  onRibbonChange
}: ChatRibbonsProps) => {
  const ribbons = [{
    id: "messages" as RibbonType,
    label: "Messages",
    icon: MessageCircle
  }, {
    id: "address" as RibbonType,
    label: "Address",
    icon: MapPin
  }, {
    id: "media" as RibbonType,
    label: "Media",
    icon: Image
  }];
  return <div className="flex border-b border-ice-white/20 bg-carbon">
      {ribbons.map(({
      id,
      label,
      icon: Icon
    }) => <Button key={id} variant="ghost" onClick={() => onRibbonChange(id)} className="">
          <Icon className="w-4 h-4 mr-2" />
          {label}
        </Button>)}
    </div>;
};
export default ChatRibbons;